export default __webpack_public_path__ + "static/media/day_close.24307c5f.svg";